import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('zubie-spinner')
export class ZubieSpinner extends LitElement {
  @property({type: String})
  color?: string = '#5742e0';

  @property({type: String, attribute: 'grow-shrink-duration'})
  growShrinkDuration?: string = '1.5s';

  @property({type: String})
  height?: string;

  @property({type: String, attribute: 'rotate-duration'})
  rotateDuration?: string = '5s';

  @property({type: String, attribute: 'stroke-width'})
  strokeWidth?: string = '5';

  @property({type: String})
  width?: string;

  override render() {
    return html`
      <svg
        width="${this.width}"
        height="${this.height}"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="${this.color}"
          stroke-width="${this.strokeWidth}"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="${this.rotateDuration}"
            repeatCount="indefinite"
          />

          <animate
            attributeName="stroke-dasharray"
            values="1, 150; 90, 150; 1, 150"
            dur="${this.growShrinkDuration}"
            repeatCount="indefinite"
          />

          <animate
            attributeName="stroke-dashoffset"
            values="0; -35; -125"
            dur="${this.growShrinkDuration}"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'zubie-spinner': ZubieSpinner;
  }
}
